import React from "react";
import { Card, Button, Tag, Typography, Row, Col, Space,} from "antd";

import {  LeftOutlined } from "@ant-design/icons";

import "../../../assets/dist/ConsumerProject/Consumer/ConsumerDashboardNewStyle.css";
import { routes } from "../../../routes/Routes";
import { useHistory } from "react-router-dom";

const { Text } = Typography;

const GoOnMyApplications = () => {
  const history = useHistory();

  const goToMyApplications = () => {
    history.push(routes.consumerDashboard.path);
  };

  return (
    <>
      {/* Top Section */}
      <Row  >
        <Col span={24} >
          <Space  >
            <Button
              type="default"
              icon={<LeftOutlined />}
              onClick={goToMyApplications}
            >
              Go to My Applications
            </Button>
          </Space>
        </Col>
      </Row>
    </>
  );
};

export default GoOnMyApplications;
